/*
 * @Author: qinjing 18137813334@163.com
 * @Date: 2023-08-09 13:26:31
 * @LastEditors: qinjing 18137813334@163.com
 * @LastEditTime: 2023-08-09 14:35:05
 * @FilePath: \hkmc-h5\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import axios from "axios"
import { baseUrl } from './assets/js/api.js' //doudou 钱包
import setUrl from './assets/js/apiOther.js' //其他需要配置的url地址
import { Toast, Loading, Button, Swipe, SwipeItem } from "vant";
import VueScroller from 'vue-scroller'; //下拉刷新
// 引入通配
import "./assets/css/base.css"


router.beforeEach((to, form, next) => {
    const fullPath = to.fullPath
    if(fullPath.startsWith('//#')) {
        // 此场景 解决安卓 协议地址写错，跳转路由失败的问题
        // 示例： http://192.168.126.102:8080/#//#/mxkPrivateAgreement
        const redirect_path = fullPath.split('//#')[1]
        next(redirect_path)
    }
    next()
})
// 引入公共css
import "./assets/css/common.css"
Vue.use(Toast);
Vue.use(Loading);
Vue.use(Button);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(VueScroller);
Vue.config.productionTip = false
Vue.prototype.$baseUrl = baseUrl;
Vue.prototype.$setUrl = setUrl;
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
